import type React from "react";
import type { FormEvent, MouseEvent } from "react";
import { translateNodeLabel } from "~/components/KratosFlow/translate";
import { handleUnexpectedError } from "~/utils/errorHandler";
import type { NodeInputProps } from "./helpers";

export const NodeInputButton: React.FC<NodeInputProps> = ({
	node,
	attributes,
	setValue,
	disabled,
	dispatchSubmit,
}) => {
	// Some attributes have dynamic JavaScript - this is for example required for WebAuthn.
	const onClick = (e: MouseEvent | FormEvent<HTMLFormElement>) => {
		// This section is only used for WebAuthn. The script is loaded via a <script> node
		// and the functions are available on the global window level. Unfortunately, there
		// is currently no better way than executing eval / function here at this moment.
		//
		// Please note that we also need to prevent the default action from happening.
		if (attributes.onclick) {
			e.stopPropagation();
			e.preventDefault();
			const run = new Function(attributes.onclick);
			run();
			return;
		}

		setValue(attributes.value)
			.then(() => dispatchSubmit(e))
			.catch(handleUnexpectedError);
	};

	return (
		<div className="w-full inline-block text-center mt-8">
			<button
				type="button"
				onClick={onClick}
				className="btn btn-lg btn-t4-primary rounded-full"
				name={attributes.name}
				value={attributes.value || ""}
				disabled={attributes.disabled || disabled}
			>
				{translateNodeLabel(node)}
			</button>
		</div>
	);
};
